'use client'

import { ReactNode, useEffect } from 'react'
import dynamic from 'next/dynamic'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import useDatagrailPerformanceConsent from './use-datagrail-performance-consent'
import initializePosthog from './initialize-posthog'

// Dynamic imports ensure we can maintain the ability to render pages server-side
// https://posthog.com/tutorials/nextjs-app-directory-analytics#capturing-pageviews-on-the-client-side
const SuspendedAppRouterPageView = dynamic(
	() => import('./app-router-page-view'),
	{
		ssr: false,
	}
)

// Due to PostHog being a performance tool, we can only initialize if the user provides consent
// for performance cookies. Using the Datagrail event listeners, we check the user's consent
// preferences and only render the PostHog provider if they've consented to performance cookies.
export default function PostHogProviderAppRouter({
	children,
}: {
	children: ReactNode
}) {
	const categoryPerformanceConsent = useDatagrailPerformanceConsent()

	useEffect(() => {
		if (categoryPerformanceConsent) {
			initializePosthog('appRouter')
		}
	}, [categoryPerformanceConsent])

	if (categoryPerformanceConsent) {
		return (
			<PostHogProvider client={posthog}>
				<SuspendedAppRouterPageView />
				{children}
			</PostHogProvider>
		)
	} else {
		return children
	}
}
